import TableView from "../../Common/TableView";
import { FaturacaoFornecedoresTableConfigs } from "./FaturacaoFornecedoresConfig";
import { FATURACAO_FORNECEDORES_EXTENSION, generalObjectBuilder, genericDelete, genericGetWithProcessor, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../../services/api.service";


export default function FaturacaoFornecedores() {

    return (<div>
        <TableView
                title={"Faturação Fornecedores"}

            postEntity={genericPost(FATURACAO_FORNECEDORES_EXTENSION)}
            editEntity={genericUpdate(FATURACAO_FORNECEDORES_EXTENSION)}
            deleteEntity={genericDelete(FATURACAO_FORNECEDORES_EXTENSION)}
            addButtonText={"Nova Fatura"}
            tableConfigs={FaturacaoFornecedoresTableConfigs}
            dataBuildFunction={generalObjectBuilder(FaturacaoFornecedoresTableConfigs)}
            entityName={"Fatura de Fornecedor"}
            idProp={"code"}
            reroute={true}
            configMapKey={'faturacao-fornecedores'}
        />
    </div>)

}

